export default {
  "notificationService.title.success": {
    en: "Success!",
    es: "¡Hecho!",
  },
  "notificationService.title.ups": {
    en: "Oops!",
    es: "¡Ups!",
  },
  "notificationService.title.remember": {
    en: "Remember!",
    es: "¡Recuerda!",
  },
  "notificationService.title.importError": {
    en: "Import error!",
    es: "¡Error en la importación!",
  },

  "notificationService.message.changeStatusToApproved": {
    en: "Proposal status changed to approved.",
    es: "Estado del presupuesto cambiado a aceptado.",
  },
  "notificationService.message.changeStatusToRejected": {
    en: "Proposal status changed to rejected.",
    es: "Estado del presupuesto cambiado a rechazado.",
  },
  "notificationService.message.archive": {
    en: "Proposal archived.",
    es: "Presupuesto archivado.",
  },
  "notificationService.message.unarchive": {
    en: "Proposal returned to active status.",
    es: "Presupuesto devuelto a activos.",
  },
  "notificationService.message.removeQuote": {
    en: "Proposal removed.",
    es: "El presupuesto se ha borrado correctamente.",
  },
  "notificationService.message.exportQuote": {
    en: "Proposal exported.",
    es: "Exportado correctamente.",
  },
  "notificationService.message.deleteContact": {
    en: "Contact deleted.",
    es: "El contacto se ha borrado correctamente.",
  },
  "notificationService.message.saveContact": {
    en: "Contact saved.",
    es: "Contacto guardado correctamente.",
  },
  "notificationService.message.saveCostFolder": {
    en: "Cost folder saved.",
    es: "Carpeta guardada correctamente.",
  },
  "notificationService.message.saveCost": {
    en: "Cost saved.",
    es: "Coste guardado correctamente.",
  },
  "notificationService.message.costsImported": {
    en: "Costs imported.",
    es: "Costes importados correctamente.",
  },
  "notificationService.message.costFolderDeleted": {
    en: "Cost folder deleted.",
    es: "Carpeta borrada correctamente.",
  },
  "notificationService.message.costDeleted": {
    en: "Cost deleted.",
    es: "Coste borrado correctamente.",
  },
  "notificationService.message.costMoved": {
    en: "Item moved.",
    es: "El elemento se ha movido correctamente.",
  },
  "notificationService.message.tariffSaved": {
    en: "Rate saved.",
    es: "Tarifa guardada correctamente.",
  },
  "notificationService.message.deleteTariff": {
    en: "Rate deleted.",
    es: "Tarifa eliminada correctamente.",
  },
  "notificationService.message.organizationDataSaved": {
    en: "Organization information updated.",
    es: "Datos actualizados correctamente.",
  },
  "notificationService.message.imageSaved": {
    en: "Image saved.",
    es: "Imagen guardada correctamente.",
  },
  "notificationService.message.setAppLanguage": {
    en: "Language updated.",
    es: "Idioma actualizado correctamente.",
  },
  "notificationService.message.setQuoteLanguage": {
    en: "Default proposal language updated.",
    es: "Idioma por defecto de los prespuestos actualizado correctamente.",
  },
  "notificationService.message.setApproveFromPublicView": {
    en: "Default allow to accept proposal online updated.",
    es: "Permitir aceptar propuesta online por defecto actualizado correctamente.",
  },
  "notificationService.message.setPdfDownloadable": {
    en: "Default pdf downloadable by client updated.",
    es: "PDF descargable por el cliente por defecto actualizado correctamente.",
  },
  "notificationService.message.setSignatureDefault": {
    en: "Default signature required to approve proposals updated.",
    es: "Firma requerida para aceptar presupuestos por defecto actualizada correctamente.",
  },
  "notificationService.message.setTimezone": {
    en: "Timezone updated.",
    es: "Zona horaria actualizada correctamente.",
  },
  "notificationService.message.setExpirationPeriod": {
    en: "Expiration updated.",
    es: "Validez actualizada correctamente.",
  },
  "notificationService.message.setSignature": {
    en: "Signature updated.",
    es: "Firma actualizada correctamente.",
  },
  "notificationService.message.invite": {
    en: "We've just sent the invitation.",
    es: "Acabamos de enviar la invitación.",
  },
  "notificationService.message.reInvite": {
    en: "We've just resent the invitation.",
    es: "Acabamos de reenviar la invitación.",
  },
  "notificationService.message.emailUpdated": {
    en: "Email address changed. We've just sent you an email to verify the new email address. Check on Spam.",
    es: "El email se ha cambiado. Te hemos enviado un correo electrónico para verificar el nuevo email. Revisa tu carpeta de spam.",
  },
  "notificationService.message.passwordUpdated": {
    en: "Password updated.",
    es: "Contraseña cambiada correctamente.",
  },
  "notificationService.message.costSaved": {
    en: "Cost saved on library.",
    es: "Coste guardado en la biblioteca correctamente.",
  },
  "notificationService.message.quoteRemoved": {
    en: "Proposal deleted.",
    es: "El presupuesto se ha borrado correctamente.",
  },
  "notificationService.message.sectionSaved": {
    en: "Section saved.",
    es: "Sección guardada correctamente.",
  },
  "notificationService.message.quoteTemplateSaved": {
    en: "Proposal template created.",
    es: "Plantilla creada correctamente.",
  },
  "notificationService.message.quoteTemplateUpdated": {
    en: "Proposal template updated.",
    es: "Plantilla actualizada correctamente.",
  },
  "notificationService.message.sectionDeleted": {
    en: "Section deleted.",
    es: "Sección eliminada correctamente.",
  },
  "notificationService.message.templateDoesNotExist": {
    en: "Template code not found.",
    es: "No existe ninguna plantilla con este código.",
  },
  "notificationService.message.templateAlreadyImported": {
    en: "Template already imported.",
    es: "Ya has importado esta plantilla a tu organización.",
  },
  "notificationService.message.quoteTemplateDeleted": {
    en: "Proposal template deleted.",
    es: "Plantilla eliminada correctamente.",
  },
  "notificationService.message.quoteTemplateImported": {
    en: "Proposal template imported.",
    es: "Plantilla importada correctamente.",
  },
  "notificationService.message.quoteTemplateRenamed": {
    en: "Proposal template renamed.",
    es: "Plantilla renombrada correctamente.",
  },
  "notificationService.message.emailToCustomerOnAccept": {
    en: "Settings updated",
    es: "Ajustes guardados",
  },
};
